import React, { useEffect, useState } from "react";
import { RiCloseCircleFill } from "react-icons/ri";
import back from "../../Asset/product/back.png";
import addressModel from "../../model/address.model";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { toast } from "../../lib/helper";
import delete1 from "../../Asset/delete1.png";

const AddressView = ({ viewaddress, setViewAddress }) => {
  const [listData, setListData] = useState();
  const [loading, setLoading] = useState(false);
  const Navigate = useNavigate();

  const GetList = async () => {
    setLoading(true);
    addressModel
      .GetAddress()
      .then((responce) => {
        setListData(responce?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };
  useEffect(() => {
    GetList();
  }, []);

  const deleteAdderess = (id) => {
    addressModel
      .DeleteAddress(id)
      .then((responce) => {
        toast(responce?.data?.message, delete1);
        GetList();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  return (
    <div
      className="w-full fixed inset-0 bg-black/50 flex justify-center items-center overflow-y-auto "
      onClick={() => setViewAddress(false)}
    >
      <div
        className="xl:w-2/5 md:w-1/2 lg:w-1/2 sm:w-11/12 w-11/12 bg-white rounded-xl shadow-lg shadow-textColor"
        style={{ backgroundImage: `url(${back})` }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="  rounded-3xl   w-full h-full flex items-center justify-center">
          <div className="p-4  md:p-3 sm:p-6 xl:p-4 lg:p-5 2xl:p-8  top-0 w-full ">
            <div className="">
              <div className="flex justify-end  items-center">
                <RiCloseCircleFill
                  className=" text-4xl lg:text-3xl md:text-xl cursor-pointer hover:text-red-500 pb-0"
                  onClick={() => setViewAddress(false)}
                />
              </div>
              <div className="w-full">
                <button
                  className="bg-textColor text-white w-48 py-1 rounded-3xl"
                  onClick={() => {
                    Navigate("/addaddresss");
                    setViewAddress(false);
                  }}
                >
                  + Add Address
                </button>
              </div>
              <hr className="w-full my-3 pt-0.5 bg-textColor" />
              {loading ? (
                <div className="w-full flex justify-center items-center p-4">
                  <span className="loading loading-ring loading-xs"></span>
                  <span className="loading loading-ring loading-sm"></span>
                  <span className="loading loading-ring loading-md"></span>
                  <span className="loading loading-ring loading-lg"></span>
                  <span className="loading loading-ring loading-xl"></span>
                </div>
              ) : (
                <>
                  <div className="w-full">
                    <span className="text-textColor text-lg font-bold title1 ">
                      Saved Addresses
                    </span>
                  </div>
                  <div className="max-h-[400px] overflow-y-auto overflow-x-hidden w-full px-2 py-0.5">
                    {listData?.map((item, index) => {
                      return (
                        <div className="w-full p-6 bg-white rounded-xl shadow-lg mt-2 transform transition duration-300 hover:scale-105 cursor-pointer">
                          <div className="flex items-center justify-between">
                            <span className="bg-textColor text-white py-0.5 px-3 rounded-2xl">
                              {item?.address_type}
                            </span>
                            <div className="flex items-center gap-2">
                              <div className="w-7 h-7 rounded-full bg-textcolor2 flex items-center justify-center" onClick={()=>{
                                Navigate(`/editaddress/${item?._id}`);
                                setViewAddress(false);
                              }}>
                                <MdEdit className="text-white" />
                              </div>
                              <div
                                className="w-7 h-7 rounded-full bg-textcolor2 flex items-center justify-center cursor-pointer"
                                onClick={() => {
                                  deleteAdderess(item?._id);
                                }}
                              >
                                <MdDelete className="text-white " />
                              </div>
                            </div>
                          </div>
                          <div className="mt-2">
                            <span className=" text-textColor py-0.5 px-3 rounded-md">
                              {item?.house_number},{item?.society_name}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressView;
